export class IndClaimSubmission{
    id: number;
    claimSubmitterName: string;
    policyNumber: string;
    yearOfBirthPolicyOwner: number;
    claimSubmitterMobileNumber: string;
    indClaimSubmitterRole: number;
    claimTypeId: number;
    claimTypePrefix: string;
    browserId: string;
    componentValidatorId: number;
}